import { render, staticRenderFns } from "./CategoryInsights.vue?vue&type=template&id=519c3e41&scoped=true"
import script from "./CategoryInsights.vue?vue&type=script&lang=ts"
export * from "./CategoryInsights.vue?vue&type=script&lang=ts"
import style0 from "./CategoryInsights.vue?vue&type=style&index=0&id=519c3e41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c3e41",
  null
  
)

export default component.exports